<!-- <div class=""> -->
<!-- <label class="control-label"><strong>Full street address</strong></label> -->
<input class="form-control" placeholder="Enter an address" name="address-auto-complete" ngx-google-places-autocomplete [options]="{types: [],componentRestrictions: { country: 'AU' }}" #placesRef="ngx-places" (onAddressChange)="handleAddressChange($event)" onfocus="this.setAttribute('autocomplete', 'no-thanks')" />
<!-- <small class="text-muted">Start typing the full street address and select the appropriate result.</small> -->
<!-- </div> -->
